import AOTravellerEnquiryStoreES6 from '@atomic/organisms/_common/header/traveller-enquiry-store_es6';
import {
  sendGoogleEvent, sendRequest, byWindowAction,
} from './utils';

export const siteLinksInitiateTracking = () => {
  $('.js-footer-site-links__list-item-link').on('click', (event) => {
    const $clickedElement = $(event.currentTarget);
    const $clickedElementItem = $clickedElement.closest(
      '.js-footer-site-links__list-item',
    );

    const link = $clickedElement.attr('href');
    const title = $clickedElementItem
      .closest('.js-footer-site-links__list')
      .prev('.js-footer-site-links__title')
      .text()
      .trim();

    if (typeof link === 'undefined' || link === false) {
      return;
    }

    sendGoogleEvent(
      `Footer - ${title}`,
      link,
      `Index: ${$clickedElementItem.index() + 1}`,
    );
  });
};

export const siteLinksInitiate = () => {
  siteLinksInitiateTracking();
};

export const siteExternalsInitiateTracking = () => {
  $('.js-footer-site-externals__social-network-button').on(
    'click',
    (event) => {
      const $clickedElement = $(event.currentTarget);
      const link = $clickedElement.attr('href');

      if (typeof link === 'undefined' || link === false) {
        return;
      }

      sendGoogleEvent(
        'Footer Social sharing',
        link,
        `Index: ${$clickedElement.index() + 1}`,
      );
    },
  );

  $('.js-footer-site-externals__app-provider-button').on(
    'click',
    (event) => {
      const $clickedElement = $(event.currentTarget);
      const isApple = $clickedElement.hasClass(
        'js-footer-site-externals__app-provider-button--apple',
      );

      const action = isApple ? 'Download ios' : 'Download android';

      sendGoogleEvent(
        'Footer - app download',
        action,
        'Footer app download',
      );
    },
  );
};

export const siteExternalsInitiate = () => {
  siteExternalsInitiateTracking();
};

let facebookInitiated = false;

export const copyrightShowFacebook = (template) => {
  $('.js-footer-copyright__fb-area .fb').prepend(template);
};

export const copyrightInitiateFacebook = () => {
  const $window = $(window);
  const $fbArea = $('.js-footer-copyright__fb-area');

  if (!$fbArea.length) {
    return;
  }

  byWindowAction(['scroll'], () => {
    if (facebookInitiated) {
      return;
    }

    if ($window.scrollTop() + $window.height() >= $fbArea.offset().top) {
      return;
    }

    facebookInitiated = true;
    sendRequest(
      '/api/common/component/footer_facebook',
      {},
      (data) => {
        if (data.status !== 'OK') {
          return;
        }
        copyrightShowFacebook(data.component);
      },
    );
  });
};

export const copyrightInitiate = () => {
  copyrightInitiateFacebook();
};

export const socialTracking = () => {
  $('body').on('click', '.js-social__link', (event) => {
    const $clickedElement = $(event.currentTarget);
    const clickedElementLink = $clickedElement.attr('href');

    if (
      typeof clickedElementLink === typeof undefined
            || clickedElementLink === false
    ) {
      return;
    }

    sendGoogleEvent(
      'Footer Social sharing',
      clickedElementLink,
      `Index: ${$clickedElement.index() + 1}`,
    );
  });
};

export const travellerEnquiryStore = new AOTravellerEnquiryStoreES6();
